export default [
  {
    url: '/static/images/tinder/Porada-Лампа Pileo Bassa.jpg',
    name: 'Лампа Pileo Bassa',
    by: 'Porada'
  },
  {
    url: '/static/images/tinder/B&B Italia-Кресло UP 50.jpg',
    name: 'Кресло UP 50',
    by: 'B&B Italia'
  },
  {
    url: '/static/images/tinder/B&B Italia-Кушетка Сharles .jpg',
    name: 'Кушетка Сharles ',
    by: 'B&B Italia'
  },
  {
    url: '/static/images/tinder/Baleri Italia-Диван Canape Cactus.jpg',
    name: 'Диван Canape Cactus',
    by: 'Baleri italia'
  },
  {
    url: '/static/images/tinder/Baxter-Сервант Plisse.jpg',
    name: 'Сервант Plisse',
    by: 'Baxter'
  },
  {
    url: '/static/images/tinder/Boca do Lobo-Cтол Pietra Oval.jpg',
    name: 'Cтол Pietra Oval',
    by: 'Boca do Lobo'
  },
  {
    url: '/static/images/tinder/Boca do Lobo-Витрина Palace.jpg',
    name: 'Витрина Palace',
    by: 'Boca do Lobo'
  },
  {
    url: '/static/images/tinder/Boca do Lobo-Тумба Diamond Pirate.jpg',
    name: 'Тумба Diamond Pirate',
    by: 'Boca do Lobo'
  },
  {
    url: '/static/images/tinder/Capdell-Софа Plum 560S.jpg',
    name: 'Софа Plum 560S',
    by: 'Capdell'
  },
  {
    url: '/static/images/tinder/Casala-Кушетка Finch metal .jpg',
    name: 'Кушетка Finch metal ',
    by: 'Casala'
  },
  {
    url: '/static/images/tinder/Casalis-Ковер Unfold.jpg',
    name: 'Ковер Unfold',
    by: 'Casalis'
  },
  {
    url: '/static/images/tinder/Casamilano-Подвесной светильник Andromeda.jpg',
    name: 'Подвесной светильник Andromeda',
    by: 'Casamilano'
  },
  {
    url: '/static/images/tinder/Cc_tapis-Ковер Check.jpg',
    name: 'Ковер Check',
    by: 'Cc_tapis'
  },
  {
    url: '/static/images/tinder/Contardi-Cветильник Stardust.jpg',
    name: 'Cветильник Stardust',
    by: 'Contardi'
  },
  {
    url: '/static/images/tinder/COR-Софа Mell.jpg',
    name: 'Софа Mell',
    by: 'COR'
  },
  {
    url: '/static/images/tinder/Ditre Italia-Настольный светильник Tondina.jpg',
    name: 'Настольный светильник Tondina',
    by: 'Ditre Italia'
  },
  {
    url: '/static/images/tinder/Fritz Hansen-Зеркало Mirror .jpg',
    name: 'Зеркало Mirror ',
    by: 'Fritz Hansen'
  },
  {
    url: '/static/images/tinder/Fritz Hansen-Стул ANT 3101.jpg',
    name: 'Стул ANT 3101',
    by: 'Fritz Hansen'
  },
  {
    url: '/static/images/tinder/Fritz Hansen-Стул China chair.jpg',
    name: 'Стул China chair',
    by: 'Fritz Hansen'
  },
  {
    url: '/static/images/tinder/GAN-Ковер Nuances Volcano.jpg',
    name: 'Ковер Nuances Volcano',
    by: 'GAN'
  },
  {
    url: '/static/images/tinder/Glas Italia-Книжный шкаф Quantum.jpg',
    name: 'Книжный шкаф Quantum',
    by: 'Glas Italia'
  },
  {
    url: '/static/images/tinder/Glas Italia-Стул Merci Bob.jpg',
    name: 'Стул Merci Bob',
    by: 'Glas Italia'
  },
  {
    url: '/static/images/tinder/Il Giardino di Legno-Софа Mozaic_noce.jpg',
    name: 'Софа Mozaic_noce',
    by: 'Il Giardino di Legno'
  },
  {
    url: '/static/images/tinder/Mineheart-Картина Submerged #3 Type.jpg',
    name: 'Картина Submerged #3 Type',
    by: 'Mineheart'
  },
  {
    url: '/static/images/tinder/Molteni&C-Витрина 45°.jpg',
    name: 'Витрина 45°',
    by: 'Molteni&C'
  },
  {
    url: '/static/images/tinder/Molteni&C-Кресло Kensington.jpg',
    name: 'Кресло Kensington',
    by: 'Molteni&C'
  },
  {
    url: '/static/images/tinder/Molteni&C-Столик Panna Cotta.jpg',
    name: 'Столик Panna Cotta',
    by: 'Molteni&C'
  },
  {
    url: '/static/images/tinder/Moooi-Диван Something Like This.jpg',
    name: 'Диван Something Like This',
    by: 'Moooi'
  },
  {
    url: '/static/images/tinder/Moooi-Комод Zio Buffet .jpg',
    name: 'Комод Zio Buffet ',
    by: 'Moooi'
  },
  {
    url: '/static/images/tinder/Moooi-Подвесной светильник Mega Сhandelier.jpg',
    name: 'Подвесной светильник Mega Сhandelier',
    by: 'Moooi'
  },
  {
    url: '/static/images/tinder/Moooi-Подвесной светильник Raimond.jpg',
    name: 'Подвесной светильник Raimond',
    by: 'Moooi'
  },
  {
    url: '/static/images/tinder/Moroso-Диван Double Soft Big Easy.jpg',
    name: 'Диван Double Soft Big Easy',
    by: 'Moroso'
  },
  {
    url: '/static/images/tinder/Moroso-Диван Josh.jpg',
    name: 'Диван Josh',
    by: 'Moroso'
  },
  {
    url: '/static/images/tinder/Moroso-Кровать Tropicalia.jpg',
    name: 'Кровать Tropicalia',
    by: 'Moroso'
  },
  {
    url: '/static/images/tinder/Moroso-Подставки для цветов Jardin Suspendu.jpg',
    name: 'Подставки для цветов Jardin Suspendu',
    by: 'Moroso'
  },
  {
    url: '/static/images/tinder/Moroso-Пуф Brook.jpg',
    name: 'Пуф Brook',
    by: 'Moroso'
  },
  {
    url: '/static/images/tinder/Oblure-Настольный светильник Balance.jpg',
    name: 'Настольный светильник Balance',
    by: 'Oblure'
  },
  {
    url: '/static/images/tinder/Pedrali-Диван Tribeca 3666.jpg',
    name: 'Диван Tribeca 3666',
    by: 'Pedrali'
  },
  {
    url: '/static/images/tinder/Porada-Cтол рабочий Micol.jpg',
    name: 'Cтол рабочий Micol',
    by: 'Porada'
  },
  {
    url: '/static/images/tinder/Porada-Консоль Eley.jpg',
    name: 'Консоль Eley',
    by: 'Porada'
  },
  {
    url: '/static/images/tinder/Porada-Стеллаж Gallery Cell.jpg',
    name: 'Стеллаж Gallery Cell',
    by: 'Porada'
  },
  {
    url: '/static/images/tinder/Riva 1920-Собачья будка Geppo.jpg',
    name: 'Собачья будка Geppo',
    by: 'Riva 1920'
  },
  {
    url: '/static/images/tinder/Riva 1920-Столик Yin&Yang.jpg',
    name: 'Столик Yin&Yang',
    by: 'Riva 1920'
  },
  {
    url: '/static/images/tinder/Riva 1920-Тумба для гостиной Iron Low.jpg',
    name: 'Тумба для гостиной Iron Low',
    by: 'Riva 1920'
  },
  {
    url: '/static/images/tinder/Roche Bobois-Кровать Backstage.jpg',
    name: 'Кровать Backstage',
    by: 'Roche Bobois'
  },
  {
    url: '/static/images/tinder/Salvatori-Книжный шкаф Colonnata.jpg',
    name: 'Книжный шкаф Colonnata',
    by: 'Salvatori'
  },
  {
    url: '/static/images/tinder/Sancal-Софа La Isla.jpg',
    name: 'Софа La Isla',
    by: 'Sancal'
  },
  {
    url: '/static/images/tinder/Schönbuch-Витрина Show Case.jpg',
    name: 'Витрина Show Case',
    by: 'Schönbuch'
  },
  {
    url: '/static/images/tinder/Toulemonde Bochart-Ковер Osaka.jpg',
    name: 'Ковер Osaka',
    by: 'Toulemonde Bochart'
  },
  {
    url: '/static/images/tinder/Ulivi-Диван Daniel.jpg',
    name: 'Диван Daniel',
    by: 'Ulivi'
  },
  {
    url: '/static/images/tinder/Ulivi-Диван Samuel.jpg',
    name: 'Диван Samuel',
    by: 'Ulivi'
  },
  {
    url: '/static/images/tinder/Ulivi-Лампа Mimi.jpg',
    name: 'Лампа Mimi',
    by: 'Ulivi'
  },
  {
    url: '/static/images/tinder/Verpan-Напольный светильник Wire.jpg',
    name: 'Напольный светильник Wire',
    by: 'Verpan'
  },
  {
    url: '/static/images/tinder/Verpan-Подвесной Светильник  VP Globe Glass.jpg',
    name: 'Подвесной Светильник  VP Globe Glass',
    by: 'Verpan'
  },
  {
    url: '/static/images/tinder/Wittmann-Софа Alleegasse.jpg',
    name: 'Софа Alleegasse',
    by: 'Wittmann'
  },
  {
    url: '/static/images/tinder/Zanotta-Кресло Lama.jpg',
    name: 'Кресло Lama',
    by: 'Zanotta'
  },
  {
    url: '/static/images/tinder/Zanotta-Стол Fenice.jpg',
    name: 'Стол Fenice',
    by: 'Zanotta'
  },
  {
    url: '/static/images/tinder/Zanotta-Стул Eva.jpg',
    name: 'Стул Eva',
    by: 'Zanotta'
  },
  {
    url: '/static/images/tinder/Zanotta-Тумба Speed.jpg',
    name: 'Тумба Speed',
    by: 'Zanotta'
  },
  {
    url: '/static/images/tinder/Мoooi-Ковер Dreamstatic.jpg',
    name: 'Ковер Dreamstatic',
    by: 'Мoooi'
  },
  {
    url: '/static/images/tinder/Моroso-Ковер Shadows.jpg',
    name: 'Ковер Shadows',
    by: 'Моroso'
  },
  {
    url: '/static/images/tinder/Моroso-Кресло Shadowy.jpg',
    name: 'Кресло Shadowy',
    by: 'Моroso'
  }
]



// WEBPACK FOOTER //
// ./src/js/TinderData.js